<template>
  <div>
    <YouTube :src="videoId" :resize="true" :fit-parent="true" ref="youtube" @playing="playing"></YouTube>
  </div>
</template>

<script>

import YouTube from 'vue3-youtube';

export default {
  components:{
    YouTube
  },
  name: "VueYoutube",
  props: {
    videoId: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      //console.log('\o/ we are watching!!!')
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    }
  }
}
</script>

<style>

iframe {
  /*width: 100%;*/
  max-width: 800px; /* Also helpful. Optional. */
}

</style>